<template>
  <v-list-item @click="logout">
    <v-list-item-avatar><font-awesome-icon :icon="['fal', 'sign-out']" /></v-list-item-avatar>
    <v-list-item-content>ログアウト</v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'auth-toolkit-logout',
  methods: {
    logout: function () {
      this.$router.push('/logout')
    }
  }
}
</script>